import React, { useState, useRef, useEffect } from 'react';

/* Адрес считается валидным, если:
   - не короче 10 символов;
   - содержит хотя бы одну цифру (номер дома/строения);
   - состоит из допустимых символов и начинается с буквы/цифры.
   «ывавыва», «тест», «ппп» — отклоняются; «Балашиха, ул. Октябрьская, 33» — проходит. */
const ADDRESS_RE = /^(?=.*\d)[а-яёa-z0-9][а-яёa-z0-9\s.,\-/()№]{9,}$/i;

function validateAddress(value) {
    const v = (value || '').trim();
    if (!v) return '';
    if (v.length < 10) return 'Адрес слишком короткий: укажите город, улицу и дом';
    if (!/\d/.test(v)) return 'В адресе нет номера дома: формат — город, улица, дом';
    if (!ADDRESS_RE.test(v)) return 'Похоже на опечатку. Формат: город, улица, дом (например: Москва, ул.Крылатская, 35)';
    return '';
}

const PickupSelector = ({ onSelect, selected }) => {
    const [network, setNetwork] = useState('wb');
    const [address, setAddress] = useState('');
    const [hint, setHint] = useState(null); // { type: 'ok' | 'err', text }
    const debounceRef = useRef(null);

    const networkLabel = network === 'wb' ? 'Wildberries' : 'Ozon';

    const applyOrReject = (value) => {
        const v = (value || '').trim();
        if (!v) {
            onSelect(null);
            setHint(null);
            return;
        }
        const err = validateAddress(v);
        if (err) {
            onSelect(null);           // сбрасываем выбор, чтобы чекаут не прошёл
            setHint({ type: 'err', text: err });
            return;
        }
        onSelect({
            id: 'manual',
            name: networkLabel,
            address: `${networkLabel}, ${v}`,
        });
        setHint({ type: 'ok', text: 'Адрес пункта выдачи подтверждён' });
        if (typeof window.ym === 'function') {
            window.ym(112121340, 'reachGoal', 'pickup_selected');
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setAddress(value);
        setHint(null);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => applyOrReject(value), 600);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (debounceRef.current) clearTimeout(debounceRef.current);
        applyOrReject(address);
    };

    const switchNetwork = (net) => {
        setNetwork(net);
        // если адрес уже введён и валиден — пересоздаём выбор с новой сетью
        if (address.trim() && !validateAddress(address)) {
            const label = net === 'wb' ? 'Wildberries' : 'Ozon';
            onSelect({ id: 'manual', name: label, address: `${label}, ${address.trim()}` });
        }
    };

    useEffect(() => () => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
    }, []);

    const inputCls =
        'w-full p-3 border border-[#E8E3DD] rounded-lg text-sm focus:outline-none focus:border-[#6B7A6A] transition';

    return (
        <div className="space-y-3">
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => switchNetwork('wb')}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium border transition ${network === 'wb'
                        ? 'bg-[#6B7A6A] text-white border-[#6B7A6A]'
                        : 'border-[#E8E3DD] bg-white'
                        }`}
                >
                    Wildberries
                </button>
                <button
                    type="button"
                    onClick={() => switchNetwork('ozon')}
                    className={`flex-1 py-2 rounded-lg text-sm font-medium border transition ${network === 'ozon'
                        ? 'bg-[#6B7A6A] text-white border-[#6B7A6A]'
                        : 'border-[#E8E3DD] bg-white'
                        }`}
                >
                    Ozon
                </button>
            </div>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={address}
                    onChange={handleChange}
                    placeholder="Город, улица, дом (например: Москва, ул.Крылатская, 35)"
                    className={inputCls}
                />
                <button type="submit" className="btn-primary w-full mt-2 py-2 text-sm">
                    Подтвердить адрес
                </button>
            </form>
            {hint && (
                <p className={`text-xs font-medium ${hint.type === 'ok' ? 'text-[#6B7A6A]' : 'text-red-600'}`}>
                    {hint.type === 'ok' ? '✅' : '⚠️'} {hint.text}
                </p>
            )}
            {selected && (
                <p className="text-xs text-[#6B7A6A] font-medium">
                    ✅ Выбран пункт: {selected.address}
                </p>
            )}
            <p className="text-xs text-gray-500">
                Укажите адрес ближайшего пункта выдачи {networkLabel} — он подтвердится автоматически
            </p>
        </div>
    );
};

export default PickupSelector;